import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { PieChartContainer } from '../../../common/chart/pieChart'
import { Element } from '../../../common/html/element'
import { getUnique } from '../../../helpers/common'
import { formatVal, valToPercent } from '../../../helpers/value'
import { selectRawHighLight } from '../store/slice'
import classes from './index.module.scss'
import { selectScoreYearOfOperation } from './store/slice'

const ChartComponent = () => {
  const data = useSelector(selectScoreYearOfOperation())
  const chartId = useRef(getUnique())
  const dataWithoutTotal = data.filter(
    (item) => item.analysisIndicatorTypeId !== 0,
  )

  const locale = useSelector((state) => state.i18n.locale)
  const highLight = useSelector(selectRawHighLight)

  return (
    <div className={classes.chart}>
      <PieChartContainer
        chartId={chartId?.current}
        data={dataWithoutTotal}
        width={180}
        height={180}
        innerRadius="55%"
        labelCenter={{
          title: (
            <>
              <span>{highLight.totalCompanies}</span>{' '}
              <Translate value="portfolio.summary.COMPANIES" />
            </>
          ),
          outerRadius: '55%',
          style: { color: '#3A414B' },
        }}
        isLabelActive={false}
        renderCustomTooltip={({ payload }) => {
          const item = payload?.[0]?.payload?.payload

          if (item) {
            return (
              <Element style={{ color: '#ECECEC' }}>
                <span>{item.analysisIndicatorTypeName}</span>
                <div style={{ marginTop: 8 }}>
                  {formatVal(item.numberCompanies, locale, false, 0)}{' '}
                  <Translate value="portfolio.summary.COMPANIES" />
                </div>
                <div style={{ marginTop: 4, whiteSpace: 'nowrap' }}>
                  {valToPercent(item.percentCompanies, locale)}{' '}
                  <Translate value="portfolio.summary.OF_TOTAL_COMPANIES" />
                </div>
              </Element>
            )
          }
        }}
      />
    </div>
  )
}

export default ChartComponent
